<template>
  <el-col :span="24" class="content">
    <vue-particles 
      class="vue-particles" 
      color="#77EFFF" 
      :particleOpacity="0.8" 
      :particlesNumber="100" 
      shapeType="circle" 
      :particleSize="3" 
      linesColor="#77EFFF" 
      :linesWidth="2" 
      :lineLinked="true" 
      :lineOpacity="0.4" 
      :linesDistance="110" 
      :moveSpeed="1.8" 
      :hoverEffect="true" 
      hoverMode="grab" 
      :clickEffect="true" 
      clickMode="push">
    </vue-particles>
    <div style="margin-top: 15px;" id="search-box">
      <div>
        <el-input placeholder="请输入您想检索的申请号，专利名称，洛迦诺分类号或申请人名称" v-model="input" >
          <el-select v-model="select" slot="prepend">
            <el-option label="全部" value="1"></el-option>
            <el-option label="申请号" value="2"></el-option>
            <el-option label="专利名称" value="3"></el-option>
            <el-option label="洛迦诺分类号" value="4"></el-option>
            <el-option label="申请人" value="5"></el-option>
          </el-select>
        </el-input>
        <el-button type="primary" icon="el-icon-search" @click="searchJudge">搜索</el-button>
      </div>
      <div id="image-upload">
        <p>上传图片：（仅限 jpg/jpeg/png/gif 格式文件，且不超过 2MB）</p>
        <el-upload
          multiple
          action="http://co.nercdh.cn:3388/patents/imgUpload"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload"
          :on-remove="handleRemove"
          list-type="picture-card">
          <i class="el-icon-plus"></i>
        </el-upload>
      </div>
    </div>
  </el-col>
</template>

<script>
  export default {
    name: 'home',
    data() {
      return {
        user:{},
        input: '',
        select: '1',
        params: {
          keyword: '',
          apply_num: '',
          name: '',
          class_num: '',
          apply_people: '',
          image_array: []
        }
      }
    },
    mounted() {
      let user=sessionStorage.getItem('user');
      if(user){
        this.user=JSON.parse(user);
      }
    },
    methods: {
      handleAvatarSuccess(res){
        this.params.image_array.push(res.data);
      },
      beforeAvatarUpload(file) {
        if(!this.user.username){
          this.$message.error('您当前还没有登录，请登录账户');
          return;
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        const isJPG = file.type === 'image/jpg';
        const isJPEG = file.type === 'image/jpeg';
        const isPNG = file.type === 'image/png';
        const isGIF = file.type === 'image/gif';
        if(!(isJPG || isJPEG || isPNG || isGIF)){
          this.$message.error('图片格式不对，仅限jpg/jpeg/png/gif格式文件');
        }
        if(!isLt2M){
          this.$message.error('上传图片的大小不能超过 2MB!')
        }
        return (isJPG || isJPEG || isPNG || isGIF) && isLt2M;
      },
      handleRemove(file) {
        let index = this.params.image_array.findIndex( fileItem => fileItem === file.response)
        this.params.image_array.splice(index, 1);
      },
      searchJudge() {
        if(!this.user.username){
          this.$message.error('您当前还没有登录，请登录账户');
          return;
        }
        if(this.input == "" && this.params.image_array.length == 0) {
          this.$message.error('请输入搜索内容');
        }else {
          if(this.select == '1'){
            this.params.keyword = this.input;
          } else if(this.select == '2'){
            this.params.apply_num = this.input;
          } else if(this.select == '3'){
            this.params.name = this.input;
          } else if(this.select == '4'){
            this.params.class_num = this.input;
          } else if(this.select == '5'){
            this.params.apply_people = this.input;
          }
          sessionStorage.setItem("keyword",this.params.keyword);
          sessionStorage.setItem("apply_num",this.params.apply_num);
          sessionStorage.setItem("name",this.params.name);
          sessionStorage.setItem("class_num",this.params.class_num);
          sessionStorage.setItem("apply_people",this.params.apply_people);
          sessionStorage.setItem("image_array",JSON.stringify(this.params.image_array));
          this.$router.push({name:'result'});
          //window.open("/main/result", "_blank");
        }
      },
      
    }
  }

</script>

<style scoped>
  #particles-js {
    height: 100%;
    width: 100%;
  }
  .content {
    display: flex;
    height: calc(100vh - 208px);
    background: url("~@/assets/earth.jpg") no-repeat;
    overflow: hidden;
    background-size:cover;
  }
  #search-box {
    position: absolute;
    width: 50%;
    left: 25%;
    top: 20%;
  }
  .el-input {
    width: calc(100% - 142px);
    margin-right: 24px;
    font-size: 16px;
  }
  .el-select {
    width: 128px;
  }
  .el-select-dropdown__item.selected {
    color: #1287C9;
  }
  ::v-deep .el-input__inner{
    height: 56px;
  }
  
  .el-button--primary  {
    height: 56px;
    font-size: 16px !important;
    padding: 0px 32px 0px 32px;
  }

  #image-upload {
    background-color: rgb(255,255,255,0.6);
    display: block;
    margin-top: 24px;
    border: 1px dashed #5795B8;
    border-radius: 8px;
    padding: 8px 0 24px 32px;
  }

  #image-upload p {
    font-size: 14px;
    color: #1D2129;
  }

  .block {
    margin-bottom: 16px;
  }
</style>
